<p-selectButton
  [options]="themeModeOptions"
  (onChange)="onChange($event)"
  [(ngModel)]="currentThemeMode"
  optionLabel="label"
  optionValue="value"
  aria-labelledby="basic"
  size="small"
>
  <ng-template #item let-item>
    <i [class]="item.icon" pTooltip="{{item.tooltip}}" tooltipPosition="bottom" showDelay="500"></i>
    @if (showLabel) {
      <span class="ml-2">{{ item.label }}</span>
    }
  </ng-template>
</p-selectButton>
